import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormGroup, FormControl } from '@angular/forms';
var CheckboxComponent = /** @class */ (function () {
    function CheckboxComponent() {
        this.propagateChange = function () { };
        this.setDisabledState = function () { };
        this.inverted = false;
        this.disabledActiveText = false;
        // Use this to pass in a custom validator function
        this.externalValidation = undefined;
    }
    CheckboxComponent.prototype.ngOnInit = function () {
    };
    CheckboxComponent.prototype.toggle = function () {
        this.val = !this.val;
    };
    CheckboxComponent.prototype.ngOnChanges = function (changes) { };
    Object.defineProperty(CheckboxComponent.prototype, "val", {
        // Create a valididation function
        get: function () {
            return this._val;
        },
        set: function (val) {
            this._val = val;
            this.propagateChange(this._val);
        },
        enumerable: true,
        configurable: true
    });
    // Called when form is initialized, with form model's initial value
    CheckboxComponent.prototype.writeValue = function (value) {
        if (value !== undefined)
            this.val = value;
    };
    // Access to a function that informs the outside world about changes
    CheckboxComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    // Callback whenever a form input is touched (ex: on blur, fires touch event)
    CheckboxComponent.prototype.registerOnTouched = function (event) {
    };
    return CheckboxComponent;
}());
export { CheckboxComponent };
